import { gql } from '@apollo/client';
import { CONVERSATION_FIELDS_FRAGMENT } from './conversationFieldsFragment.gql';

const FIND_CONVERSATIONS_QUERY = gql`
  ${CONVERSATION_FIELDS_FRAGMENT}
  query findConversations($filter: ConversationFilter, $sorting: [ConversationSort!], $paging: CursorPaging) {
    conversationsFind(filter: $filter, sorting: $sorting, paging: $paging) {
      nodes {
        ...ConversationFields
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
    }
  }
`;

const GET_TAG_HISTORY_AND_COMBINED_TAGS_QUERY = gql`
  query getTagHistoryAndCombinedTags($conversationId: String!) {
    conversationGet(id: $conversationId) {
      id
      combinedTags
      tagHistory
    }
  }
`;

const GET_CONVERSATION_QUERY = gql`
  ${CONVERSATION_FIELDS_FRAGMENT}
  query getConversation($conversationId: String!) {
    conversationGet(id: $conversationId) {
      ...ConversationFields
    }
  }
`;

const GET_ACTIVE_EXPERT_QUEUES_QUERY = gql`
  query getActiveExpertQueues($filter: ExpertQueueFilter, $sorting: [ExpertQueueSort!], $paging: CursorPaging) {
    expertQueuesFind(filter: $filter, sorting: $sorting, paging: $paging) {
      nodes {
        id
        createdAt
        updatedAt
        Comments
        isActive
        nominatedAt
        assignedAt
        messageArrivedAt
        nominationExpiresAt
        simplrExpertId
        conversationId
        messageId
      }
    }
  }
`;

const NOMINATED_EXPERT_QUEUE = gql`
  query getNominatedExpertQueue($filter: ExpertQueueFilter) {
    expertQueueFindFirst(filter: $filter) {
      simplrExpertPtr {
        objectId: id
      }
    }
  }
`;

const VALIDATION_TICKETS_QUEUE = gql`
  query getValidationTicketsQueue($filter: ConversationFilter, $sorting: [ConversationSort!], $paging: CursorPaging) {
    conversationsFind(filter: $filter, sorting: $sorting, paging: $paging) {
      nodes {
        ticketId: id
        subject
        brand
        smbName
        simplrTicketNumber
        communicationType
        platformTicketId
        platformDomain
        ticketType: conversationType
        fromChannel: customerChannel
        simplrAccountPtrId: simplrAccountId
        ticketStatus: status
        customerPtr {
          id
          customerEmail
          customerFirstName
        }
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
    }
  }
`;

export {
  FIND_CONVERSATIONS_QUERY,
  GET_TAG_HISTORY_AND_COMBINED_TAGS_QUERY,
  GET_CONVERSATION_QUERY,
  GET_ACTIVE_EXPERT_QUEUES_QUERY,
  NOMINATED_EXPERT_QUEUE,
  VALIDATION_TICKETS_QUEUE,
};
